import { render } from "./SchemaMarkup.vue?vue&type=template&id=d075cab0"
import script from "./SchemaMarkup.vue?vue&type=script&lang=js"
export * from "./SchemaMarkup.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__